// setApiBaseUrl.ts
import api from './api';

export function setApiBaseUrl(baseURL: string) {
  api.defaults.baseURL = baseURL;
}
